<template>
<div>
  <card>
    <template slot="header">
      <h4 class="card-title">Customer Information</h4>
    </template>
    <div class="row">
      <div class="col-md-6">
        <el-form ref="form" :model="form" label-width="140px">
          <el-form-item label="TH Name">
            <el-input v-model="form.thName" name="thName" v-validate="'required'" clearable></el-input>
            <span class="el-form-item__error">{{ errors.first('thName') }}</span>
          </el-form-item>

          <el-form-item label="EN Name">
            <el-input v-model="form.enName" name="enName" v-validate="'required'" clearable></el-input>
            <span class="el-form-item__error">{{ errors.first('enName') }}</span>
          </el-form-item>

          <el-form-item label="TH Full Name">
            <el-input v-model="form.thFullName" name="thFullName" v-validate="'required'" clearable></el-input>
            <span class="el-form-item__error">{{ errors.first('thFullName') }}</span>
          </el-form-item>

          <el-form-item label="EN Full Name">
            <el-input v-model="form.enFullName" name="enFullName" v-validate="'required'" clearable></el-input>
            <span class="el-form-item__error">{{ errors.first('enFullName') }}</span>
          </el-form-item>

          <el-form-item label="Web Hook URL">
            <el-input v-model="form.webhook" name="webhook" clearable></el-input>
          </el-form-item>

          <el-form-item label="Address">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              placeholder="Address"
              v-model="form.address">
            </el-input>
          </el-form-item>

          <el-form-item label="Description">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              placeholder="Description"
              v-model="form.description">
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button @click="$router.push(`/manifest`)">Back</el-button>
            <el-button type="warning" @click="onSubmit">Update</el-button>
            <el-button @click="getData">Reset</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    </card>
  </div>
</template>


<script>
import Vue from "vue"
import { Autocomplete } from "element-ui"
import { Card } from 'src/components/UIComponents'
import * as _apiCustomer from "@/api/customer"
import {
  Table,
  TableColumn,
  Select,
  Option,
  Tabs,
  TabPane,
  Button,
  Tooltip,
  Form,
  FormItem,
  Input,
  Checkbox,
  Notification,
  DatePicker,
  Tag,
  Scrollbar,
  Row,
  Col,
} from "element-ui"
import PPagination from "src/components/UIComponents/Pagination.vue"
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(Option)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Button)
Vue.use(Tooltip)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(DatePicker)
Vue.use(Tag)
Vue.use(Scrollbar)
Vue.use(Row)
Vue.use(Col)

Vue.use(Autocomplete)

export default {
  components: {
    Card,
  },
  data() {
    return {
      inputSearch: '',
      form: {
        thName: '',
        enName: '',
        thFullName: '',
        enFullName: '',
        webhook: '',
        address: '',
        description: ''
      },
      isSearchFound: true,
    }
  },
  watch: {
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      _apiCustomer.get(this.$route.params.id)
        .then(response => {
          console.log(response)
          this.form = response.data
        })
        .catch(e => {
          this.$notify({
            message: e,
            type: 'danger'
          })
        });
    },
    onSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.update()
          // this.$notify({
          //   message: 'XXX',
          //   type: 'success'
          // })
        } else {
          this.$notify({
          message: 'Please enter all required information',
            type: 'danger'
          })
        }
        //
      }).catch(() => {
        this.$notify({
          message: e,
          type: 'danger'
        })
      })
    },
    update () {
      _apiCustomer.update(this.form.id, this.form)
        .then(response => {
          this.$notify({
            message: 'Update Successfully',
            type: 'success'
          })
          this.getData()
        })
        .catch(error => {
          this.$notify({
            message: error.response.data.message || 'Unsuccessfully',
            type: 'danger'
          })
        });
    },
  }
}
</script>
